export type Lang = 'en' | 'pt';

type Dict = Record<string, string>;

const en: Dict = {
  'scroll': 'Scroll',
  'hero-card-trust': 'Trusted by drivers across Madeira',
  'hero-card-reviews': '5-star reviews',

  'hero-feat1-h': 'Island-Wide Coverage',
  'hero-feat1-p': 'We come to you, anywhere.',
  'hero-feat2-h': 'Fast Response',
  'hero-feat2-p': 'Quick arrival, expert service.',
  'hero-feat3-h': 'Fully Insured',
  'hero-feat3-p': 'Your vehicle is in safe hands.',

  'stat-exp-sub': 'From Funchal to Porto Moniz, we come to you.',
  'stat-cars-sub': 'Same-day and pre-booked visits available.',
  'stat-rating-sub': 'Clear pricing approved before work starts.',
  'stat-resp-sub': 'Professional liability coverage for every job.',

  'sec-svc-label': 'What We Do',
  'sec-svc-h2': 'Our Services',
  'svc-foot-title': 'Expert Care. Wherever You Are.',
  'svc-foot-sub': 'Trusted by drivers across Madeira Island.',

  'trust-label': 'Why Choose Us',
  'trust-h2': 'Trusted by Hundreds<br>of Madeiran Drivers',
  'feat1-h': 'Fully Insured',
  'feat1-p': 'All work is covered by professional liability insurance for your complete peace of mind.',
  'feat2-h': 'Punctual & Reliable',
  'feat2-p': 'We confirm appointments, show up on schedule, and keep you informed every step of the way.',
  'feat3-h': 'Transparent Pricing',
  'feat3-p': 'No surprise bills. You receive a clear quote before any work begins. Always.',
  'feat4-h': 'Island-Wide Coverage',
  'feat4-p': 'From Funchal to Porto Moniz, we cover every corner of Madeira Island.',

  'sec-rev-label': 'Client Reviews',
  'review-verified': 'Verified Client',
  'review-src-prefix': 'Google',

  'sec-areas-label': 'Service Coverage',
  'sec-areas-note': 'Typical drive times from our Caniço base depend on traffic and current bookings. For urgent breakdowns on the ER101, ER104, ER209 or via expressa, call {{phone}} directly.',

  'sec-tour-label': 'Tourists & Rental Cars',
  'sec-tour-h2': "Stranded with a rental car? <em>We're 5 minutes from Madeira Airport.</em>",
  'sec-tour-p': 'Dead battery in a hotel car park. Engine warning light on the way to Cabo Girão. Flat tyre on the ER101. We work with English-speaking tourists in Madeira every day. Emergency mobile mechanic service across the island, no towing required, no Portuguese needed.',
  'tour-feat1-h': 'Madeira Airport (FNC)',
  'tour-feat1-p': 'Based in Caniço, the closest mobile mechanic to Madeira Airport. Roadside help for arriving travellers and rental car issues.',
  'tour-feat2-h': 'English Spoken Daily',
  'tour-feat2-p': 'No language barrier. We explain the issue clearly and quote in plain English before any work begins.',
  'tour-feat3-h': 'Hotel, Villa, or Roadside',
  'tour-feat3-p': 'We come to your accommodation, the rental return, the airport, or the side of the road, anywhere on Madeira.',

  'sec-loc-label': 'Where We Operate',
  'sec-loc-h2': 'Madeira Island',
  'loc-base': 'Base Location',
  'loc-directions': 'Get directions',
  'loc-phone': 'Phone',
  'loc-email': 'Email',
  'loc-payment': 'Payment Methods',
  'loc-hours': 'Working Hours',

  'sec-faq-label': 'Frequently Asked',
  'sec-form-label': 'Get In Touch',
  'sec-form-p': "Fill in the form and we'll get back to you to confirm your appointment.",
  'prefer-call': 'Prefer to call?',

  'lbl-fname': 'First Name',
  'lbl-lname': 'Last Name',
  'lbl-email': 'Email',
  'lbl-phone': 'Phone',
  'lbl-vehicle': 'Vehicle Make & Model',
  'lbl-year': 'Year',
  'lbl-service': 'Service Required',
  'lbl-address': 'Your Location / Address',
  'lbl-msg': 'Message',
  'opt-select': 'Select a service...',
  'opt-other': 'Other',
  'btn-send': 'Send Request',
  'btn-sending': 'Sending...',
  'form-note': 'We typically respond within 2–4 hours during business hours.',
  'form-success': "Thank you! We'll be in touch shortly to confirm your booking.",
  'form-error': 'An error occurred while sending. Please try again or contact us directly.',

  'footer-rights': 'All rights reserved.',
};

const pt: Dict = {
  'scroll': 'Rolar',
  'hero-card-trust': 'A confiança dos condutores em toda a Madeira',
  'hero-card-reviews': 'avaliações de 5 estrelas',

  'hero-feat1-h': 'Cobertura em Toda a Ilha',
  'hero-feat1-p': 'Vamos até si, em qualquer zona.',
  'hero-feat2-h': 'Resposta Rápida',
  'hero-feat2-p': 'Chegada rápida, serviço especializado.',
  'hero-feat3-h': 'Totalmente Segurado',
  'hero-feat3-p': 'O seu veículo está em boas mãos.',

  'stat-exp-sub': 'Do Funchal ao Porto Moniz, vamos até si.',
  'stat-cars-sub': 'Disponível no próprio dia ou por marcação.',
  'stat-rating-sub': 'Preço claro e aprovado antes de iniciar.',
  'stat-resp-sub': 'Cobertura de responsabilidade em cada serviço.',

  'sec-svc-label': 'O Que Fazemos',
  'sec-svc-h2': 'Os Nossos Serviços',
  'svc-foot-title': 'Cuidado Especializado. Onde Estiver.',
  'svc-foot-sub': 'A confiança dos condutores em toda a Madeira.',

  'trust-label': 'Porquê Escolher-nos',
  'trust-h2': 'A Confiança de Centenas<br>de Condutores Madeirenses',
  'feat1-h': 'Totalmente Segurado',
  'feat1-p': 'Todo o trabalho é coberto por seguro de responsabilidade profissional para sua total tranquilidade.',
  'feat2-h': 'Pontual e Fiável',
  'feat2-p': 'Confirmamos marcações, chegamos a horas e mantemos-o informado em cada etapa.',
  'feat3-h': 'Preços Transparentes',
  'feat3-p': 'Sem faturas surpresa. Recebe um orçamento claro antes de qualquer trabalho começar.',
  'feat4-h': 'Cobertura em Toda a Ilha',
  'feat4-p': 'De Funchal ao Porto Moniz, cobrimos todos os cantos da Ilha da Madeira.',

  'sec-rev-label': 'Avaliações de Clientes',
  'review-verified': 'Cliente Verificado',
  'review-src-prefix': 'Google',

  'sec-areas-label': 'Áreas Servidas',
  'sec-areas-note': 'Os tempos indicados são estimativas a partir da nossa base no Caniço, o tempo real depende do trânsito e das marcações do dia. Para avarias urgentes na ER101, ER104, ER209 ou via expressa, ligue diretamente para {{phone}}.',

  'sec-tour-label': 'Turistas e Carros de Aluguer',
  'sec-tour-h2': 'Avaria com carro de aluguer? <em>Estamos a 5 minutos do aeroporto da Madeira.</em>',
  'sec-tour-p': 'Bateria descarregada no estacionamento do hotel. Luz do motor acesa a caminho do Cabo Girão. Pneu furado na ER101. Trabalhamos diariamente com turistas na Madeira, serviço de mecânico móvel de emergência em toda a ilha, sem necessidade de reboque.',
  'tour-feat1-h': 'Aeroporto da Madeira (FNC)',
  'tour-feat1-p': 'Sediados no Caniço, o mecânico móvel mais próximo do aeroporto da Madeira. Apoio em estrada para passageiros que chegam e problemas com carros de aluguer.',
  'tour-feat2-h': 'Falamos Inglês Diariamente',
  'tour-feat2-p': 'Sem barreira linguística. Explicamos o problema com clareza e damos orçamento em linguagem simples antes de qualquer trabalho começar.',
  'tour-feat3-h': 'Hotel, Vivenda ou Estrada',
  'tour-feat3-p': 'Vamos ao seu alojamento, ao stand de aluguer, ao aeroporto ou à beira da estrada, em qualquer ponto da Madeira.',

  'sec-loc-label': 'Onde Operamos',
  'sec-loc-h2': 'Ilha da Madeira',
  'loc-base': 'Localização Base',
  'loc-directions': 'Ver direções',
  'loc-phone': 'Telefone',
  'loc-email': 'Email',
  'loc-payment': 'Métodos de Pagamento',
  'loc-hours': 'Horário de Funcionamento',

  'sec-faq-label': 'Perguntas Frequentes',
  'sec-form-label': 'Entre em Contacto',
  'sec-form-p': 'Preencha o formulário e entraremos em contacto para confirmar a marcação.',
  'prefer-call': 'Prefere ligar?',

  'lbl-fname': 'Nome',
  'lbl-lname': 'Apelido',
  'lbl-email': 'Email',
  'lbl-phone': 'Telefone',
  'lbl-vehicle': 'Marca e Modelo',
  'lbl-year': 'Ano',
  'lbl-service': 'Serviço Pretendido',
  'lbl-address': 'A Sua Localização / Morada',
  'lbl-msg': 'Mensagem',
  'opt-select': 'Selecionar serviço...',
  'opt-other': 'Outro',
  'btn-send': 'Enviar Pedido',
  'btn-sending': 'A enviar...',
  'form-note': 'Normalmente respondemos em 2–4 horas durante o horário de funcionamento.',
  'form-success': 'Obrigado! Entraremos em contacto em breve para confirmar a marcação.',
  'form-error': 'Ocorreu um erro ao enviar o pedido. Por favor tente novamente ou contacte-nos diretamente.',

  'footer-rights': 'Todos os direitos reservados.',
};

const dictionaries: Record<Lang, Dict> = { en, pt };

export function translate(lang: Lang, key: string, vars?: Record<string, string>): string {
  const raw = dictionaries[lang][key] ?? dictionaries.en[key] ?? key;
  if (!vars) return raw;
  return raw.replace(/\{\{(\w+)\}\}/g, (_, name) => vars[name] ?? '');
}
